import { useState, useEffect } from 'react'

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { formatDateForBirth } from "../../dates";
import { PATHS } from "../../paths";


import {
  Container,
  Header,
  Button,
  Segment,
  Form,
  FormInput,
  // FormField
} from 'semantic-ui-react'

import { gql, useMutation } from '@apollo/client';
import { useNavigate } from 'react-router-dom';

const UPDATE_USER = gql`
    mutation UpdateUser($name: String, $dob: String, $address: String) {
        updateUser(name: $name, dob: $dob, address: $address) {
            id
        }
    }
`;

const Onboarding = () => {
    const navigate = useNavigate();
    const [name, setName] = useState("");
    const [address, setAddress] = useState("");
    const [dobDate, setDobDate] = useState<Date | null>(new Date());
    const [graphqlDobDate, setGraphqlDobDate] = useState<string | "">("");
    const [showErrors, setShowErrors] = useState(false);

    useEffect(() => {
        setGraphqlDobDate(formatDateForBirth(new Date().getTime()));
    }, [setGraphqlDobDate]);

    const [updateUser] = useMutation(UPDATE_USER);


    const handleSave = async () => {
        setShowErrors(true);

        if (name.length < 1 || address.length < 1 || graphqlDobDate.length < 1) {
            return;
        }

        await updateUser({ variables: { name, dob: graphqlDobDate, address } });

        navigate(PATHS.ORGANISATIONS);
    }

    return (
      <Segment style={{ padding: '2em 0em' }} vertical>
        <Container>
            <Header as='h1'>Onboarding</Header>
            <Form>
                <FormInput
                    error={showErrors && name.length < 1 && 'Please enter your name'}
                    fluid
                    label='Name'
                    placeholder='Name'
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />
                <FormInput>
                    <label>Date of birth</label>
                    <DatePicker
                        selected={dobDate}
                        dateFormat="dd/MM/yyyy"
                        onChange={(date) => {
                            setGraphqlDobDate(formatDateForBirth(date?.getTime() || 0))
                            setDobDate(date)
                        }}
                        showYearDropdown
                        maxDate={new Date()}
                    />
                </FormInput>
                <FormInput
                    error={showErrors && address.length < 1 && 'Please enter your address'}
                    fluid
                    label='Address'
                    placeholder='Address'
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                />
                <Button onClick={() => handleSave()}>Save details</Button>
            </Form>
        </Container>
      </Segment>
  )
}

export { Onboarding }
